module.exports = __webpack_public_path__ + "static/img/mobile_bg.61f5b544.png";